import React from 'react';

import DPEReport from '../../components/Prospecting/DPEReport';

function DPEReportView() {
  return (
    <DPEReport />
  );
}

export default DPEReportView;
